import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem("authToken") || null);
    const [employee, setEmployee] = useState(
        JSON.parse(localStorage.getItem("employeeData")) || null
    );
    const navigate = useNavigate();

    const login = (data) => {
        const { token, employee } = data; // Extract token and employee

        console.log("✅ Storing token and employee in localStorage:", token, employee);

        // Save in localStorage separately
        localStorage.setItem("authToken", token);
        localStorage.setItem("employeeData", JSON.stringify(employee));

        // Update state
        setToken(token);
        setEmployee(employee);
    };

    const logout = () => {
        console.log("❌ Logging out. Removing token and employee data.");
        localStorage.removeItem("authToken");
        localStorage.removeItem("employeeData");
        setToken(null);
        setEmployee(null);
        navigate("/employee/login");
    };

    const getToken = () => token;
    const getEmployee = () => employee;

    useEffect(() => {
        setToken(localStorage.getItem("authToken"));
        setEmployee(JSON.parse(localStorage.getItem("employeeData")));
    }, []);

    return (
        <AuthContext.Provider value={{ token, employee, login, logout, getToken, getEmployee }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
